import React from 'react';
import './ScoreBox.css';

// Translucent "SCORE" panel shown on the game screens.
export default function ScoreBox({ value }) {
  return (
    <div className="score-box">
      <div className="score-box-label">SCORE</div>
      <div className="score-box-value">{Number.isFinite(value) ? value : 0}</div>
    </div>
  );
}
